<template>
  <div class="messages-view">
    <div class="tab-container">
      <div class="tab-container__tabs">
        <router-link
          class="router-link"
          v-for="item in navigation.items"
          :key="item.title"
          :to="item.link"
        >
          <div class="tab-container__tabs__tab">
            <h2 class="h4">{{ item.title }}</h2>
          </div>
        </router-link>
      </div>
      <div class="tab-container__content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navigation: {
        items: [
          // {
          //   title: "customization",
          //   link: { name: "settings-customization" },
          // },
          {
            title: "languages",
            link: { name: "settings-languages" },
          },
          {
            title: "help",
            link: { name: "settings-help" },
          },
        ],
      },
    };
  },
};
</script>
<style scoped>
@media (max-width: 760px) {
  .messages-view {
    flex-direction: column;
  }
}

@media (max-width: 760px) {
  .messages-view {
    flex-direction: column;
  }
}
</style>
